<div #wrapperEl class="tcd-wrapper position-relative w-100">
	<div class="tcd-trigger d-flex align-items-center gap-2 position-relative w-100" #triggerEl (click)="togglePanel()">
	
		<ng-container *ngIf="!selectedTrackingId && selectedForCurrentCount === 0; else hasTracking">
			<div class="tcd-placeholder">{{ placeholder }}</div>
		</ng-container>
	
		<ng-template #hasTracking>
			<ng-container *ngIf="selectedForCurrentCount === 1; else multiOrZero">
				<span class="tcd-custom-chip">
					<button 
						type="button" 
						class="tcd-chip-remove"
						(click)="clearCurrentTracking(); $event.stopPropagation()">
						<i class="fa fa-times"></i>
					</button>
					<span class="tcd-chip-label">{{ selectedForCurrentArr[0]?.title }}</span>
				</span>
			</ng-container>
	
			<ng-template #multiOrZero>
				<span class="tcd-custom-chip">
					<button 
						type="button" 
						class="tcd-chip-remove"
						(click)="clearCurrentTracking(); $event.stopPropagation()">
						<i class="fa fa-times"></i>
					</button>
					<span class="tcd-chip-label">
						{{ getTrackingTitleById(selectedTrackingId) }} ({{ selectedForCurrentCount }})
					</span>
				</span>
			</ng-template>
		</ng-template>
	
		<i class="tcd-caret ms-auto" [ngClass]="panelOpen ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
	</div>

	<div 
		class="tcd-overlay position-absolute" 
		*ngIf="panelOpen" 
		[style.top.px]="panelTop" 
		[style.left.px]="panelLeft"
		[style.width.px]="panelWidth">
		<div class="tcd-panel d-flex flex-column gap-2">
			<label class="tcd-label d-inline-flex align-items-center">Tracking</label>
			<p-dropdown 
				[options]="trackingOptions" 
				[(ngModel)]="selectedTrackingId" 
				optionLabel="title"
				optionValue="id" 
				(onChange)="onTrackingChange()" 
				placeholder="Select tracking">
			</p-dropdown>

			<ng-container *ngIf="selectedTrackingId">
				<label class="tcd-label d-inline-flex align-items-center ">Client</label>
				<p-multiSelect 
					#clientMultiselect 
					[options]="clientOptions" 
					[(ngModel)]="selectedForCurrentArr"
					[dataKey]="'id'" 
					optionLabel="title" 
					[filter]="false" 
					defaultLabel="Select clients" 
					(onChange)="onClientsChange($event.value)">

					<ng-template pTemplate="filter">
						<div class="tcd-filter-wrapper d-flex justify-content-between gap-4 align-items-center w-100">
							<p-checkbox 
								[binary]="true" 
								type="checkbox" 
								[ngModel]="areAllVisibleSelected()"
								(onChange)="toggleAllClients()">
							</p-checkbox>
							<input 
								pInputText 
								class="p-inputtext client-filter-input flex-fill" 
								type="text"
								[ngModel]="clientFilter" 
								(ngModelChange)="onClientFilterInput($event)" />
							<button 
								type="button" 
								(click)="clientMultiselect.hide()" 
								class="p-multiselect-close p-link">
									<span class="p-multiselect-close-icon pi pi-times"></span>
									<span class="p-ink"></span>
							</button>
						</div>
					</ng-template>

					<ng-template pTemplate="item" let-item>
						<div>
							<span>{{ item.title }}</span>
						</div>
					</ng-template>

					<ng-template pTemplate="selectedItems">
						<ng-container [ngSwitch]="selectedForCurrentCount">
							<span *ngSwitchCase="0">
								Select clients
							</span>
							<ng-container *ngSwitchCase="1">
								<span class="tcd-custom-chip" (click)="$event.stopPropagation()">
									<button 
										type="button" 
										class="tcd-chip-remove"
										(click)="removeClient(selectedForCurrentArr[0]); $event.stopPropagation()">
											<i class="fa fa-times"></i>
									</button>
									<span class="tcd-chip-label">{{ selectedForCurrentArr[0]?.title }}</span>
								</span>
							</ng-container>
							<ng-container *ngSwitchDefault>
								<span class="tcd-custom-chip" (click)="$event.stopPropagation()">
									<button 
										type="button" 
										class="tcd-chip-remove"
										(click)="clearAllForCurrent(); $event.stopPropagation()"> 
											<i class="fa fa-times"></i></button>
									<span class="tcd-chip-label">Selected ({{ selectedForCurrentCount }})</span>
								</span>
							</ng-container>
						</ng-container>
					</ng-template>
				</p-multiSelect>
			</ng-container>

			<div class="tcd-chips d-flex flex-wrap gap-1" *ngIf="selectedForCurrentArr.length">
				<p-chip *ngFor="let c of selectedForCurrentArr; trackBy: trackClient" 
					[label]="c.title" 
					[removable]="true"
					(onRemove)="onChipRemove($event, c)">
				</p-chip>
			</div>
		</div>
	</div>